{
    "yes": "Yes",
    "no": "No",
    "confirm": "Confirm",
    "apply": "Apply",
    "cancel": "Cancel",
    "show": "Show",
    "hide": "Hide",
    "send": "Send",
    "close": "Close",
    "edit": "Edit",
    "delete": "Delete",
    "loading": "Loading",
    "expand": "Expand",
    "collapse": "Collapse",
    "fullscreenEnter": "Enter fullscreen",
    "fullscreenExit": "Exit fullscreen",
    "center": "Center",
    "bottom": "Bottom",
    "hidden": "Hidden",
    "day": "Day",
    "all": "All",
    "today": "Today",
    "yesterday": "Yesterday",
    "placeholder": "Ask a question",
    "last_7_days": "Last 7 days",
    "last_30_days": "Last 30 days",
    "month": "Month",
    "copied": "Copied!",
    "year": "Year",
    "dayPlaceholder": "DD",
    "monthPlaceholder": "MM",
    "yearPlaceholder": "YYYY",
    "createdAt": "Creation date",
    "date": "Birth date",
    "selected": "Selected",
    "page": "page",
    "actions": "Actions",
    "next": "Next",
    "previous": "Previous",
    "copy": "Copy",
    "copyRawCode": "Copy raw code",
    "copyToClipboard": "Copy to clipboard",
    "showOriginalText": "Show original",
    "showTranslatedText": "Show translation",
    "exactPosition": "Exact position",
    "uncertain": "Uncertain",
    "question": "Question",
    "nothingFound": "Nothing found",
    "venue": "Venue",
    "searchVenue": "Search venue...",
    "privacyPolicy": "Privacy policy",
    "popularLanguages": "Popular",
    "allLanguages": "All Languages",
    "memoriBlockedTitle": "Blocked",
    "memoriBlockedUntil": "Agent blocked until {{date}}",
    "memoriBlockedAnon": "Currently \"{{name}}\" can't answer, come back here on {{date}}",
    "memoriBlockedReasonExceedChats": "because it has exceeded the monthly threshold of allowed chats.",
    "memoriBlockedGiverHelper": "You can still manage it as administrator, but other users will not be able to interact with it.",
    "generatedByAI": "Answer generated by AI, may occasionally generate incorrect informations",
    "reasoning": "Reasoning...",
    "whyThisAnswer": "Why this answer?",
    "whyThisAnswerHelper": "This answer was generated automatically by an artificial intelligence based on these verified contents.",
    "receiverLabel": "Assigned to",
    "completionsEnabled": "Advanced AI, can respond with automatically generated answers that may sometimes contain incorrect information",
    "completionProviderDown": "This agent is integrated with a generative AI from {{provider}}, but it is currently unavailable. Try again later.",
    "completionProviderMajorOutage": "This agent is integrated with a generative AI from {{provider}}, but it is completely down. This feature will not be available until the service is restored.",
    "completionProviderPartialOutage": "This agent is integrated with a generative AI from {{provider}}, but it is experiencing partial outages. Some features may be unavailable or perform poorly.",
    "completionProviderDegraded": "This agent is integrated with a generative AI from {{provider}}, but it is performing slower than usual. Responses may take longer or be less accurate.",
    "completionProviderFallbackName": "an external provider",
    "completionProviderCheckStatusPage": "Check status page",
    "boardOfExperts": "Board of experts",
    "birthDate": "Birth date",
    "birthDateHelper": "We ask for your birth date only to enable or disable functionalities that have age restrictions",
    "underage": "You must be at least {{age}} years old to sign up.",
    "underageTwinSession": "You must be at least {{age}} years old to interact with this agent.",
    "errorFetchingSession": "Error during session loading",
    "errorGettingReferralURL": "Error during referral loading",
    "errorReopeningSession": "Error during session reopening",
    "ageVerification": "Age verification",
    "ageVerificationText": "To interact with this agent, you must be at least {{minAge}} years old.",
    "nsfw": "NSFW: This agent contains adult contents",
    "deepThought": "Deep Thought",
    "deepThoughtHelper": "Deep Thought is an advanced feature of the AI that will allow you to fully exploit your conversations by keeping track of them. The AI with Deep Thought can give you information tailored to you and the things you will share together. Allow the agent's author to contact you for commercial offers regarding products you have shown interest in.",
    "deepThoughtDisclaimerTitle": "Deep Thought enabled",
    "deepThoughtDisclaimer": "Deep Thought is an advanced feature of the AI that will allow you to fully exploit your conversations by keeping track of them. The AI with Deep Thought can give you information tailored to you and the things you will share together.",
    "deepThoughtPreDisclaimerUnlogged": "Log in to enable Deep Thought.",
    "deepThoughtPreDisclaimerNotAllowed": "Deep Thought is disabled since you didn't consent its usage, you can change this any time in your account settings.",
    "notEnoughCredits": "The author of this agent does not have enough credits to answer your question.",
    "confirmDialog": {
        "title": "Do you want to leave this page?",
        "message": "The changes you made will be lost."
    },
    "knownFacts": {
        "title": "Known facts",
        "description": "Details of the information shared between you and {{memoriName}}",
        "type": "Type",
        "typeShortTerm": "Short term",
        "typeLongTerm": "Long term",
        "typeHelper": "Types:\n- Short Term: this Known Fact is always used during conversations\n- Long Term: this Known Fact is used during conversations only if relevant to the current question",
        "text": "Text",
        "deleteSuccess": "Known fact deleted",
        "deleteConfirmTitle": "Delete known fact",
        "deleteConfirmMessage": "Are you sure you want to delete this known fact?",
        "deleteSelectedConfirmTitle": "Delete selected known facts",
        "deleteSelectedConfirmMessage": "Are you sure you want to delete the selected known facts?"
    },
    "auth": {
        "title": "Authentication",
        "useRecoveryTokens": "Use recovery tokens",
        "tokens": "Tokens",
        "addToken": "Add token",
        "usePassword": "Use password",
        "passwordRequired": "Password required",
        "invalidCredentials": "Invalid credentials",
        "atLeast": "At least"
    },
    "widget": {
        "instruct": "Instruct",
        "test": "Test",
        "sound": "Sound",
        "position": "Position preferences",
        "settings": "Settings",
        "share": "Share",
        "shareChat": "Share chat",
        "sendOnKeypress": "Hit Enter to send",
        "sendOnClick": "Click on Submit",
        "boardOfExperts": "Board of experts",
        "showExpertsInTheBoard": "Show experts in this board",
        "expertsInTheBoard": "Experts in this board",
        "goToIntegrationsToCustomizeAvatar": "To customize the avatar, go to Share and customize the public page"
    },
    "exportChatHistory": {
        "exportPDF": "Export chat as PDF",
        "exporting": "Exporting...",
        "empty": "No chat history to export",
        "pdfNotSupported": "PDF export is not supported in this browser",
        "success": "Chat exported to PDF successfully",
        "error": "Failed to export chat to PDF. Please try again."
    },
    "write_and_speak": {
        "micButtonPopover": "Click the button to speak",
        "micButtonPopoverListening": "Click the button to stop speak",
        "pageInstructExplanation": "To teach me new things click on the INSTRUCT ME button to get started",
        "pageTryMeExplanation": "To talk to me click on the START button to get started",
        "pagePrivacyExplanation": "The conversations are visible by the author of the agent",
        "downloadChat": "Download chat",
        "pagePrivacyExplanationList": {
            "allConversations": "All conversations with this agent are visible to the author of the agent",
            "anonymousUser": "For anonymous users: the author will see the content of the conversation and your IP address",
            "registeredUser": "For registered users: the author will see the content of the conversation and your username",
            "contentAndUsername": "The author can see the content, your username and your IP address",
            "contentAndIpAddress": "The author can see the content and your IP address",
            "authorUsesInfo": "The author uses this information to improve the features of the agent and to provide you with a better service. Continuing the conversation, you accept these conditions."
        },
        "instructButton": "INSTRUCT ME",
        "tryMeButton": "START",
        "resumeButton": "RESUME",
        "chatHistory": "Chat history",
        "chatHistoryDescription": "Show the chat history with this agent",
        "loadingChatHistory": "Loading chat history...",
        "noChatHistoryAvailable": "No chat history available",
        "noResultsFound": "No results found for \"{{searchText}}\"",
        "searchInChatHistory": "Search in chat history...",
        "latestFirst": "Latest first",
        "oldestFirst": "Oldest first",
        "exportChat": "Export Chat",
        "conversationStartedLabel": "Conversation started",
        "settingsHeaderLabel": "Setup here if you want to set the continuous speech, and change the silence seconds if you want to customize them.",
        "continuousSpeechLabel": "Continuous speech",
        "continuousSpeechDisabled": "Continuous speech disabled because the agent is in mute mode",
        "holdToSpeak": "Hold to speak",
        "releaseToEndListening": "Release to end listening",
        "pressAndHoldToSpeak": "Press and hold to speak",
        "microphoneMode": "Microphone mode",
        "hideEmissionsLabel": "Hide text emitted by the agent",
        "secondsLabel": "Set seconds",
        "controlsPosition": "Controls position",
        "avatarControls": "Avatar controls",
        "height": "Height",
        "depth": "Depth",
        "avatarType": "Avatar type",
        "suggestions": "Use the arrow keys to adjust the avatar height\nUse +/- to adjust the avatar depth",
        "blob": "Blob",
        "avatar3d": "3D Avatar",
        "zoomed": "Zoomed",
        "normal": "Normal",
        "far": "Far",
        "enablePositionControls": "Enable position controls",
        "tryMeHeaderLabel": "TRY",
        "unknownPosition": "Unknown position",
        "fieldPlace": "Write the place (eg 'Milano')",
        "showMapLinkFor": "Show the position on the map",
        "useMyPosition": "Use my position",
        "myPosition": "Your position",
        "updatingPosition": "Updating position...",
        "placeNotFound": "Place not found!",
        "requirePosition": "Insert your position before start",
        "requirePositionHelp": "To talk to {{name}} you have to decide whether to provide your position or not. This is because different answers that it can provide you may depend on where you are.",
        "dontWantToProvidePosition": "I don't want to provide my position",
        "attachmentsLabel": "Enrich your message",
        "iWantToTalkToIn": "I want to talk to {{name}} in",
        "message": "message",
        "messages": "messages",
        "page": "Page {{current}} of {{total}}"
    },
    "artifact": {
        "close": "Close",
        "size": "Size",
        "generated": "Generated",
        "download": "Download",
        "print": "Print",
        "external": "Open in a new window",
        "type": "Type",
        "fullscreen": "Fullscreen",
        "exitFullscreen": "Exit fullscreen",
        "generatedAt": "Generated at",
        "copy": "Copy",
        "open": "Open",
        "code": "Code",
        "preview": "Preview",
        "copied": "Copied!",
        "error": "Error",
        "generatingPdf": "Generating PDF...",
        "copying": "Copying...",
        "moreCopyOptions": "More copy options",
        "copyAs": "Copy as",
        "downloadAsMarkdown": "Download as Markdown",
        "downloadRawMarkdownText": "Download raw markdown text",
        "downloadAsPdf": "Download as PDF",
        "exportAsPdfDocument": "Export as PDF document",
        "downloadAsHtml": "Download as HTML",
        "downloadFormattedHtml": "Download formatted HTML",
        "viewMode": "View Mode",
        "codeMode": "Code Mode",
        "refresh": "Refresh",
        "share": "Share",
        "downloadAsJson": "Download as JSON",
        "downloadJsonData": "Download JSON data",
        "downloadAsPng": "Download as PNG",
        "downloadPngImage": "Download PNG image",
        "downloadAsJpeg": "Download as JPEG",
        "downloadJpegImage": "Download JPEG image",
        "downloadAsGif": "Download as GIF",
        "downloadGifImage": "Download GIF image",
        "downloadAsWebp": "Download as WebP",
        "downloadWebpImage": "Download WebP image",
        "copyAsSvg": "Copy as SVG",
        "copySvgSourceCode": "Copy SVG source code",
        "copyAsPlainText": "Copy as Plain Text",
        "copyAsText": "Copy as text",
        "copyAsLanguage": "Copy as {{language}}",
        "copyLanguageCode": "Copy {{language}} code",
        "copyWithoutSyntaxHighlighting": "Copy without syntax highlighting",
        "copyTextContent": "Copy text content",
        "pdfExportNotSupported": "PDF export is not supported in this browser",
        "popupBlocked": "Popup blocked! Please enable popups to print.",
        "safariPdfInstructions": "PDF export opened in new window. Please use Cmd+P (Mac) or Ctrl+P (Windows) to print and save as PDF."
    },
    "upload": {
        "loginRequired": "Login required",
        "pastedText": "pasted-text",
        "uploadNotification": "Upload Failed",
        "loginRequiredDescription": "Please login to upload images",
        "uploadFiles": "Upload files ({{shortcut}}+O to open file chooser)",
        "uploadFilesWithShortcut": "{{shortcut}}+O to open file chooser",
        "uploadImages": "Upload images",
        "replace": "Replace",
        "maxImagesReached": "You can upload up to {{max}} images",
        "maxDocumentsReached": "You can upload up to {{max}} documents",
        "remaining": "remaining",
        "lastDocumentSlot": "Upload last document",
        "uploadDocuments": "Upload documents",
        "maxReached": "Max limit reached",
        "imageTitle": "Image title: {{title}}",
        "titleHelp": "Adding a descriptive title helps the AI provide more context and appropriate responses.",
        "titlePlaceholder": "Enter image title",
        "apiClientNotConfigured": "API client not configured properly for media upload",
        "fileReadingFailed": "File reading failed",
        "uploadFailed": "Upload failed",
        "uploadSuccess": "Upload success",
        "titleImage": "Image title: {{title}}",
        "uploadSuccessDescription": "The file has been uploaded successfully",
        "titleImageUpload": "Upload images",
        "partialUpload": "Only {{uploaded}} images on {{total}} will be uploaded. Maximum {{max}} images allowed.",
        "maxImages": "Maximum {{max}} images allowed.",
        "upload": "Upload",
        "dragAndDropFiles": "Drag and drop files here to add them to the chat",
        "pasteMaxAttachmentsReached": "Maximum {{max}} attachments. Remove one to add this as a file.",
        "pasteContentTooLong": "Pasted content is too long (max {{size}}KB). Shorten or split it.",
        "pasteContentExceedsLimit": "Pasted content exceeds the size limit. Try shortening the text or splitting it into smaller parts.",
        "pasteAddedAsAttachment": "Pasted content added as attachment",
        "contextSizeExceedsLimit": "Context size exceeds the limit. Try reducing the number of files or content in the conversation.",
        "filesNotAddedMaxAllowed": "{{count}} file(s) not added (maximum {{max}} files allowed).",
        "documentsNotAddedMaxAllowed": "{{count}} document(s) not added (maximum {{max}} files allowed).",
        "imagesNotAddedMaxAllowed": "{{count}} image(s) not added (maximum {{max}} files allowed).",
        "documentsNotAddedContextSize": "{{count}} document(s) not added (context size limit)."
    },
    "media": {
        "title": "Title",
        "editAttributes": "Edit media attributes",
        "uploadMimeTypeNotAllowed": "The file type is not allowed",
        "uploadSizeLimitMessage": "The uploaded size is too big (max {{size}}MB)",
        "uploadWrongResolutionMessage": "The resolution must be {{width}}x{{height}} pixel",
        "memoriNameAlreadyUsed": "You already have an agent with this name",
        "uploadHelperImages": "Upload a file with extension png, jpg, jpeg or gif, and having at maximum a size of {{size}}MB",
        "uploadHelper": "Upload a file having at maximum a size of {{size}}MB",
        "uploadError": "Upload failed",
        "square": "square",
        "scaleRatio": "Scale ratio",
        "addMediaLabel": "Add a media",
        "insertThisMediaMsg": "Insert these media",
        "mediaUploadMessage": "Click to load a new media",
        "addLinkLabel": "Add a link",
        "linkKey": "URL",
        "linkValue": "Link title",
        "insertThisLink": "Insert a link to {{url}} with title {{title}}"
    },
    "gamification": {
        "level": "Level",
        "points": "points",
        "memoriReachedLevel": "became more evolved and reached level",
        "levelGoToStatistics": "{{memori}} is at level {{level}} with {{points}} points. Click to go to statistics.",
        "congratulationsNewLevel": "Congratulations, you have reached a new level!",
        "congratulationsNewLevelDescription": "Your agent became more evolved with {{points}} points, look at the",
        "statistics": "statistics"
    },
    "login": {
        "login": "Login",
        "logout": "Logout",
        "user": "User",
        "loggedDrawerTitle": "Hi, {{name}}!",
        "userNameRequired": "Username required",
        "userName": "Username",
        "userNamePlaceholder": "Enter username",
        "loginDrawerTitle": "Login",
        "signupDrawerTitle": "Sign up",
        "newUserSignUp": "New user?",
        "signUp": "Sign up!",
        "alreadyHaveAnAccount": "Already have an account?",
        "backToLogin": "Back to login",
        "registrationDisabled": "Registration is disabled",
        "contactAdmin": "Contact the administrator to request access",
        "userNameOrEmail": "Username or email",
        "email": "Email",
        "emailFormatError": "Please, insert a valid email",
        "username": "Username",
        "usernameContainsReservedWord": "Username contains a reserved word, please choose another one",
        "usernameFormatError": "Username must be at least 3 characters long and contain only letters, numbers and _",
        "otpCode": "Verification code",
        "resendVerificationCode": "Resend code",
        "resentVerificationCode": "Confirmation code sent! Please check your email.",
        "welcomeTitle": "Welcome back",
        "welcomeDescription": "Enter your 4-digit verification code to continue to your account",
        "otpTitle": "Enter verification code",
        "otpDescription": "Enter the 4-digit code you generated in your account",
        "otpStep1": "Click the button below to open your account",
        "otpStep2": "Generate a 4-digit verification code (valid for 60 seconds)",
        "otpStep3": "Return here and enter the code",
        "startOtpLogin": "Start verification",
        "generateOtp": "Generate code",
        "otpTimer": "Code expires in {{seconds}} seconds",
        "otpInvalidFormat": "Please enter a valid 4-digit code",
        "otpInvalid": "Invalid verification code",
        "otpError": "Error validating code. Please try again.",
        "otpSuccess": "Login successful!",
        "otpEmailTitle": "Enter your email",
        "otpEmailDescription": "Enter your email address to receive a verification code",
        "otpCodeDescription": "Enter the 4-digit code sent to {{email}}",
        "emailPlaceholder": "Enter your email",
        "sendOtp": "Send code",
        "resendOtp": "Resend code",
        "resending": "Resending...",
        "backToEmail": "Back to email",
        "otpSent": "Verification code sent!",
        "otpResent": "Code resent successfully!",
        "otpSendError": "Error sending code. Please try again.",
        "emailRequired": "Email required",
        "emailInvalid": "Please enter a valid email address",
        "otpNotFound": "Verification code not found",
        "otpExpired": "Verification code has expired",
        "otpMissing": "Verification code is required",
        "otpSuccessMessage": "Verification successful! Redirecting...",
        "otpSuccessDescription": "Your account has been verified successfully. You will be redirected shortly.",
        "otpHelp": "Enter the 4-digit code from your email",
        "emailHelp": "We'll send you a verification code",
        "userFetchError": "Error loading user data. Please try again.",
        "otpStep1Title": "Enter Email",
        "otpStep2Title": "Check Email",
        "otpStep3Title": "Enter Code",
        "featureFast": "Fast",
        "featureSecure": "Secure",
        "featureMobile": "Mobile",
        "password": "Password",
        "newPassword": "New password",
        "confirmPassword": "Confirm Password",
        "currentPassword": "Current password",
        "passwordMatchingError": "Passwords do not match.",
        "passwordFormatError": "Password must be at least 8 characters long and contain at least a number, an upper case letter, a lower case letter and a symbol",
        "pwdWeak": "Weak",
        "pwdAcceptable": "Acceptable",
        "pwdStrong": "Strong",
        "mustChangePassword": "You must change your password",
        "passwordChange": "Change password",
        "emailChange": "Change email",
        "avatarChange": "Change avatar",
        "underage": "You must be at least {{age}} years old to sign up.",
        "optional": "Optional",
        "birthDate": "Birth date",
        "birthDateHelper": "We ask for your birth date only to enable or disable functionalities that have age restrictions",
        "missingData": "Missing informations",
        "missingDataHelper": "We know that this is a bit annoying, but we need some more informations to complete your registration.",
        "goToAccountToChangeYourPreferences": "You can change your choice at any time from your Account page.",
        "deepThoughtExplaination": "Deep Thought is an advanced feature of the AI that will allow you to fully exploit your conversations by keeping track of them. The AI with Deep Thought can give you information tailored to you and the things you will share together. Allow the agent's author to contact you for commercial offers regarding products you have shown interest in.",
        "tnCAndPPAcceptedHelper": "Since your last login, T&C and Privacy Policy have changed. Please accept them, otherwise you won't be able to make changes to your Twins. You can always delete your account in your user profile page.",
        "privacyLabel": "I have read and accepted the",
        "privacyAndCookiePolicy": "Privacy e Cookie Policy",
        "and": "and",
        "termsOfService": "Terms of Service",
        "pAndCUAccepted": "I accept the terms of service about Deep Thought",
        "editAccount": "Edit account",
        "save": "Save",
        "welcomeUser": "Welcome User",
        "verified": "Verified",
        "premiumUser": "Premium",
        "quickActions": "Quick Actions",
        "editProfile": "Edit Profile",
        "notifications": "Notifications",
        "help": "Help",
        "logoutConfirm": "Are you sure you want to logout?",
        "comingSoon": "Coming soon!",
        "accountOverview": "Account Overview",
        "notSet": "Not set",
        "accepted": "Accepted",
        "pending": "Pending",
        "termsStatus": "Terms Status",
        "enabled": "Enabled",
        "disabled": "Disabled",
        "advancedFeatures": "Advanced Features",
        "successfullyLoggedIn": "{{username}} has successfully logged in"
    },
    "chatLogs": {
        "anyMessage": "Any message",
        "atLeast": "At least {{count}} messages",
        "atLeast2": "At least 2 messages",
        "atLeast3": "At least 3 messages",
        "atLeast5": "At least 5 messages",
        "atLeast10": "At least 10 messages",
        "atLeast15": "At least 15 messages",
        "atLeast20": "At least 20 messages",
        "customMinimumMessages": "Customize the number of messages"
    },
    "success": "Success",
    "Error": "Error",
    "internal server error": "Oupsie, sorry... Something went wrong on the server",
    "error": "Error",
    "error.loading": "Error while loading content.",
    "error.generic": "Oupsie, sorry... something went wrong.",
    "error.serverNotResponding": "We are doing maintenance or releasing updates. Please try again later.",
    "error.notFound": "Oupsie, we didn't find the page you were looking for.",
    "error.goBackTo": "You can try to go back to the",
    "error.reloadPage": "Reload the page",
    "error.tryAgain": "Try again",
    "error.unauthorized": "You are unauthorized to view this content.",
    "error.unprocessableEntity": "Error while processing the request. Check the data you entered.",
    "errors": {
        "TENANT_NOT_FOUND": "Tenant not found",
        "TENANT_REGISTRATION_DISABLED": "Registration on this platform is disabled",
        "TENANT_MISSING_NAME": "Tenant: name missing",
        "TENANT_MAX_USERS_REACHED": "Maximum number of users reached",
        "TENANT_MAX_ADMINS_REACHED": "Maximum number of admin users reached",
        "TENANT_ALREADY_EXISTS": "Tenant already exists",
        "TENANT_MISSING_DESCRIPTION": "Tenant: description missing",
        "TENANT_CANT_SET_COMPLETION_PROVIDER": "Tenant: can't set completion provider",
        "TENANT_INVALID_TYPE": "Tenant: invalid type",
        "USER_NOT_CONFIRMED": "User still not confirmed",
        "USER_NOT_FOUND": "User not found",
        "USER_OR_PASSWORD_INVALID": "Invalid user or password",
        "USER_MUST_CHANGE_PASSWORD": "You must change your password",
        "USER_MUST_ENTER_VERIFICATION_CODE": "You must enter the verification code",
        "USER_MISSING_TENANT": "User: missing tenant",
        "USER_MISSING_NAME": "User: name is missing",
        "USER_MISSING_PASSWORD": "User: password missing",
        "USER_MISSING_EMAIL": "User: Missing email",
        "USER_MISSING_VERIFICATION_CODE": "User: Missing verification code",
        "USER_NAME_ALREADY_USED": "User name already in use",
        "USER_PASSWORD_NOT_CONFORMING_TO_POLICY": "The password does not meet the security rules",
        "USER_EMAIL_ALREADY_USED": "Email already in use",
        "USER_EMAIL_INVALID": "Invalid email",
        "USER_VERIFICATION_CODE_INVALID": "Invalid verification code",
        "USER_MISSING_NAME_OR_EMAIL": "Missing username or email",
        "USER_NAME_INVALID": "Invalid user name",
        "USER_HAS_ONE_OR_MORE_MEMORI": "The user has one or more memories",
        "USER_MISSING_NEW_PASSWORD": "User: new password missing",
        "USER_NOTHING_TO_DO": "Nothing to do",
        "USER_CANT_CREATE_MEMORI": "User not allowed to create agents",
        "USER_MAX_MEMORI_REACHED": "Maximum number of agents reached",
        "USER_TOO_MANY_ATTEMPTS": "Too many attempts",
        "USER_MUST_ACCEPT_TNC_AND_PP": "You must accept the terms and conditions",
        "USER_BIRTH_DATE_CANT_BE_CHANGED": "Date of birth cannot be changed",
        "USER_CANT_SET_COMPLETION_PROVIDER": "User: not allowed to manage completion provider",
        "USER_CANT_ENABLE_DEEP_THOUGHT": "User: not enabled to manage Deep Thought",
        "USER_CANT_ENABLE_DCM_INTEGRATION": "User: not enabled to manage DCM integration",
        "USER_CANT_ENABLE_CHAINING_OR_BOARD_OF_EXPERTS": "User: not allowed to manage chaining or expert group",
        "USER_CREATION_BILLING_DENIED_PERMISSION": "You don't have enough credits to create an agent",
        "USER_HAS_ONE_OR_MORE_COMPLETION_CONFIGS": "The user has one or more completion configurations",
        "USER_CANT_BE_DELETED": "User can't be deleted",
        "USER_ORDER_BY_INVALID": "Order by invalid",
        "MEMORI_NOT_FOUND": "Agent not found",
        "MEMORI_NOT_ACCESSIBLE": "Agent not accessible",
        "MEMORI_ONLY_OWNER_CAN_CHANGE_GIVER_TAG_AND_PIN": "Only owner can change tag or pin",
        "SESSION_NOT_FOUND": "Session not found",
        "SESSION_IS_NOT_ADMINISTRATIVE": "Non-administrative session",
        "SESSION_EXPIRED": "Session expired",
        "SESSION_OTP_NOT_FOUND": "Verification code not found",
        "SESSION_OTP_EXPIRED": "Verification code has expired",
        "SESSION_MISSING_TEMPORARY_TOKEN": "Verification code is required",
        "MEMORI_MISSING_CONFIGURATION": "Agent: missing configuration",
        "MEMORI_CONFIGURATION_NOT_FOUND": "Agent: configuration not found",
        "MEMORI_INVALID_PRIVACY_TYPE": "Agent: invalid privacy type",
        "MEMORI_MISSING_PASSWORD": "Agent: missing password",
        "MEMORI_INVALID_TOTAL_NUMBER_OF_RECOVERY_TOKENS": "Agent: total number of invalid recovery tokens",
        "MEMORI_INVALID_MINIMUM_NUMBER_OF_RECOVERY_TOKENS": "Agent: minimum number of invalid recovery tokens",
        "MEMORI_INVALID_VOICE_TYPE": "Agent: invalid voice type",
        "MEMORI_MISSING_NAME": "Agent: missing name",
        "MEMORI_MISSING_PASSWORD_OR_RECOVERY_TOKENS": "Agent: missing password or recovery token",
        "MEMORI_INVALID_ID": "Agent: invalid ID",
        "MEMORI_NAME_ALREADY_USED": "Agent name already in use",
        "MEMORI_INVALID_PIN": "Agent: Invalid PIN",
        "MEMORI_GIVER_TAG_PIN_CHANGE_REQUIRES_SEPARATE_OPERATION": "Agent: TAG and PIN change require separate operations",
        "MEMORI_NO_PASSWORD_WHEN_PUBLIC": "Agent: no password required when public",
        "MEMORI_DEEP_THOUGHT_REQUIRES_COMPLETIONS": "Deep Thought requires completions to be enabled",
        "MEMORI_BOARD_OF_EXPERTS_REQUIRES_COMPLETIONS": "The expert group requires completions to be enabled",
        "MEMORI_INVALID_COMPLETION_CONFIG": "Agent: invalid completions configuration",
        "MEMORI_MACRO_FUNCTIONS_REQUIRES_COMPLETIONS": "Macro functions requires completions to be enabled",
        "MEMORI_BLOCKING_DATE_MISSING_OR_WRONG": "Agent: blocking date missing or wrong",
        "MEMORI_LIST_FILTER_NOT_SPECIFIED": "Agent: list filter not specified",
        "MEMORI_TRANSFER_MISSING_DESTINATION_USER": "Transfer: missing destination user",
        "MEMORI_TRANSFER_INVALID_DESTINATION_USER_ID": "Transfer: invalid destination user ID",
        "MEMORI_TRANSFER_DESTINATION_USER_DATA_INCONSISTENT": "Transfer: invalid destination user data",
        "MEMORI_TRANSFER_NOTHING_TO_DO": "Transfer: nothing to do",
        "MEMORI_CONFIGURATION_CANT_BE_CHANGED": "Agent: configuration cannot be changed",
        "MEMORI_MISSING_NEW_PASSWORD": "Agent: new password missing",
        "MEMORI_FEATURE_REQUIRES_SUBSCRIPTION": "Feature requires subscription",
        "INTEGRATION_NOT_FOUND": "Integration not found",
        "MEMORI_SESSIONS_INVALID_DATE_FROM_FORMAT": "Invalid date from format",
        "MEMORI_SESSIONS_INVALID_DATE_TO_FORMAT": "Invalid date to format",
        "MEMORI_SESSION_NOT_FOUND": "Session not found",
        "MEMORI_SESSION_DOESNT_ACCEPT_MEDIA": "Session doesn't accept media",
        "INTEGRATION_INVALID_TYPE": "Invalid integration type",
        "INTEGRATION_ALREADY_EXISTS": "Integration already exists",
        "INTEGRATION_MEMORI_IS_NOT_PUBLIC": "Non-public memories cannot be integrated",
        "INTEGRATION_MISSING_INVOCATION_TEXT": "Integration: missing invocation text",
        "INTEGRATION_MISSING_DEVICE_EMAILS": "Integration: missing device email",
        "INTEGRATION_MEMORI_IS_EMPTY": "Empty memories cannot be integrated",
        "INTEGRATION_MISSING_PRIVACY_POLICY": "Integration: privacy policy missing",
        "INTEGRATION_MISSING_CATEGORY": "Integration category missing",
        "INTEGRATION_MISSING_DESCRIPTION": "Missing integration description",
        "INTEGRATION_INVALID_INVOCATION_TEXT": "Invalid invocation text",
        "INTEGRATION_GOOGLE_NO_MORE_AVAILABLE": "Google Home no more available",
        "UPLOAD_REQUIRES_MULTIPART_ENCODING": "Upload requires multipart encoding",
        "UPLOAD_MISSING_CONTENT_TYPE_BOUNDARY": "Upload: missing content type boundary",
        "UPLOAD_MAX_LENGTH_EXCEEDED": "Upload: maximum size exceeded",
        "UPLOAD_FILE_IS_EMPTY": "Upload: empty file",
        "UPLOAD_INVALID_FILE_TYPE_OR_SIGNATURE": "Upload: invalid file type or signature",
        "UPLOAD_MISSING_FILE_NAME": "Upload: missing file name",
        "UPLOAD_INVALID_MEMORY_ID": "Upload: Invalid content ID",
        "UPLOAD_MISSING_FILE_CONTENT": "Upload: Missing file content",
        "ASSET_NOT_FOUND": "Asset not found",
        "ASSET_NOT_ACCESSIBLE": "Asset not accessible",
        "ASSET_MISSING_SESSION_ID": "Asset: missing session ID",
        "ASSET_INVALID_FILE_NAME": "Asset: invalid file name",
        "ASSET_MALWARE_SCAN_THREATS_FOUND": "Asset: found malware threats",
        "INVITATION_NOT_FOUND": "Invitation not found",
        "INVITATION_NOT_ACCESSIBLE": "Invitation not accessible",
        "INVITATION_ALREADY_ACCEPTED": "Invitation already accepted",
        "INVITATION_ALREADY_REJECTED": "Invitation already rejected",
        "INVITATION_MISSING_DESTINATION_EMAIL": "Invitation: missing destination email",
        "INVITATION_DESTINATION_EMAIL_INVALID": "Invitation: destination email invalid",
        "INVITATION_MISSING_TAG": "Invitation: missing tag",
        "INVITATION_MISSING_PIN": "Invitation: PIN missing",
        "INVITATION_INVALID_PIN": "Invitation: invalid PIN",
        "INVITATION_INVALID_TYPE": "Invitation: invalid type",
        "INVITATION_MISSING_DESTINATION_NAME": "Invitation: destination name missing",
        "INVITATION_TAG_PIN_CANT_BE_CHANGED": "Invitation: tag and pin can't be changed",
        "INVITATION_CANT_BE_CHANGED": "Intation: can't be changed",
        "ACTIONLOG_INVALID_USER_ID": "Invalid user ID",
        "ACTIONLOG_INVALID_DATE_FROM_FORMAT": "Date from: invalid format",
        "ACTIONLOG_INVALID_DATE_TO_FORMAT": "Date to: invalid format",
        "ACTIONLOG_INVALID_MEMORI_ID": "Invalid Memori ID",
        "CONSUMPTIONLOG_INVALID_TYPE": "Invalid log type",
        "CONSUMPTIONLOG_INVALID_DATE_FROM_FORMAT": "Date from: invalid format",
        "CONSUMPTIONLOG_INVALID_DATE_TO_FORMAT": "Date to: invalid format",
        "CONSUMPTIONLOG_INVALID_USER_ID": "Invalid user ID",
        "CONSUMPTIONLOG_INVALID_MEMORI_ID": "Invalid Memori ID",
        "NOTIFICATIONPREFS_INVALID_CHATLOG_EXTRACTION_PERIOD": "Notifications: Invalid chat log extraction period",
        "BROADCAST_NOT_ALLOWED": "Broadcast not allowed",
        "INVALID_NOTIFICATION_TYPE": "Invalid notification type",
        "NOTIFICATION_NOT_FOUND": "Notification not found",
        "INVALID_NOTIFICATION_FILTER": "Invalid notification filter",
        "INVALID_NOTIFICATION_PERIOD": "Invalid notification period",
        "PROCESS_INVALID_TYPE": "Invalid process type",
        "PROCESS_ALREADY_RUNNING": "Process already running",
        "PROCESS_NOT_FOUND": "Process not found",
        "IMPORTCSV_MISSING_ROWS": "CSV import: missing rows",
        "IMPORTCSV_MISSING_CSV": "CSV Import: Missing CSV",
        "IMPORTCSV_MISSING_SEPARATOR": "CSV import: missing separator",
        "IMPORTCSV_INVALID_SEPARATOR": "CSV import: invalid separator",
        "IMPORTCSV_MISSING_HEADERS": "CSV import: missing headers",
        "IMPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "CSV import: missing title variant separator",
        "IMPORTCSV_INVALID_RECEIVER_ID": "CSV import: invalid receiver ID",
        "IMPORTCSV_INVALID_MEDIA_LINK": "CSV import: invalid media link",
        "IMPORTCSV_INVALID_LINK_TITLE_HANDLING": "CSV import: invalid link title",
        "IMPORTCSV_UNDETECTABLE_CHAR_ENCODING": "CSV import: undetectable character encoding",
        "IMPORTCSV_CANT_IMPORT_TO_SECRET_MEMORI": "CSV Import: Cannot import to Secret Memories",
        "IMPORTTXT_MISSING_ROWS": "Importing TXT: missing rows",
        "IMPORTTXT_INVALID_GRANULARITY": "Import TXT: invalid granularity",
        "IMPORTTXT_INVALID_RECEIVER_ID": "Import TXT: invalid receiver ID",
        "IMPORTTXT_INVALID_MEDIA_LINK": "Import TXT: invalid media link",
        "IMPORTTXT_INVALID_LINK_TITLE_HANDLING": "Import TXT: invalid link title",
        "IMPORTTXT_UNDETECTABLE_CHAR_ENCODING": "TXT import: undetectable character encoding",
        "IMPORTTXT_CANT_IMPORT_TO_SECRET_MEMORI": "TXT Import: Cannot import to Secret Memories",
        "IMPORTTXT_IMPORT_LIMIT_EXCEEDED": "Import TXT: import limit exceeded",
        "IMPORTTXT_IMPORT_ON_GPT4_REQUIRES_API_KEY": "Import TXT: import on GPT-4 requires API key",
        "IMPORTTXT_IMPORT_REQUIRES_PAYING": "Import TXT: Import requires a paying plan",
        "IMPORTTXT_BILLING_DENIED_PERMISSION": "Import TXT: you don't have enough credits for the operation",
        "IMPORT_MISSING_ROWS": "Import: missing rows",
        "IMPORT_CANT_IMPORT_TO_SECRET_MEMORI": "Import: can't import to Secret Memories",
        "IMPORTMEMORI_INVALID_MEMORI_SPECS": "Import MEMORI: invalid memory specs",
        "IMPORT_MISSING_JSONL": "Import: missing JSONL",
        "IMPORTMEMORI_INVALID_SPECS": "Import MEMORI: invalid specs",
        "EXPORT_MISSING_PASSWORD": "Export: missing password",
        "EXPORTCSV_MISSING_CSV_SPECS": "CSV export: missing CSV specifications",
        "EXPORTCSV_MISSING_SEPARATOR": "CSV export: missing separator",
        "EXPORTCSV_INVALID_SEPARATOR": "CSV export: invalid separator",
        "EXPORTCSV_MISSING_TITLE_VARIANT_SEPARATOR": "CSV export: missing title variant separator",
        "EXPORTCSV_MISSING_NEW_LINE_CHAR": "CSV export: missing newline character",
        "EXPORTCSV_INVALID_NEW_LINE_CHAR": "CSV export: invalid newline character",
        "EXPORTCSV_MISSING_PASSWORD": "CSV export: missing password",
        "EXPORTJSONL_MISSING_JSONL_SPECS": "JSONL export: missing JSONL specifications",
        "EXPORTJSONL_MISSING_PLATFORM": "JSONL export: missing platform",
        "EXPORTJSONL_INVALID_PLATFORM": "JSONL export: invalid platform",
        "EXPORTJSONL_MISSING_PASSWORD": "JSONL export: missing password",
        "EXPORTJSONL_EXPORT_REQUIRES_PAYING": "JSONL Export: Export requires a paid plan",
        "ANALYSIS_MISSING_QUERY": "Analysis: missing query",
        "ANALYSIS_CANT_ANALYZE_SECRET_MEMORI": "Analysis: Unable to analyze Secret Memories",
        "ANALYSIS_USER_QUERY_MATCH_REQUIRES_DEEP_THOUGHT": "Analysis: matching user query requires Deep Thinking",
        "BADGE_ASSIGNMENT_WRONG_OR_MISSING_CREDENTIALS": "Badge assignment: incorrect or missing credentials",
        "BADGE_ASSIGNMENT_MISSING_REF_ID": "Badge assignment: ref ID missing",
        "BADGE_ASSIGNMENT_OUTCOME_NOT_FOUND": "Badge assignment: result not found",
        "BADGE_ASSIGNMENT_MISSING_ASSERTION_URL": "Badge assignment: Missing assertion URL",
        "BADGE_ASSIGNMENT_MISSING_BADGE_URL": "Badge Assignment: Missing Badge URL",
        "BADGE_ASSIGNMENT_MISSING_ISSUER_URL": "Badge assignment: missing issuer URL",
        "BADGE_ASSIGNMENT_INVALID_URL": "Badge assignment: Invalid URL",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT": "Badge assignment: missing recipient",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_TYPE": "Badge assignment: unknown recipient type",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_IDENTITY": "Badge assignment: missing recipient identity",
        "BADGE_ASSIGNMENT_MISSING_RECIPIENT_HASH_TYPE": "Badge assignment: missing recipient hash type",
        "BADGE_ASSIGNMENT_UNKNOWN_RECIPIENT_HASH_TYPE": "Badge assignment: recipient hash type unknown",
        "BADGE_ASSIGNMENT_WRONG_RECIPIENT_IDENTITY": "Badge assignment: incorrect recipient identity",
        "BADGE_NOT_FOUND": "Badge not found",
        "OUTCOME_NO_DCM_CONFIGURED": "Outcome: no DCM configured",
        "OUTCOME_USER_BADGES_DISABLED": "Outcome: user badges disabled",
        "COMPLETION_CONFIG_MISSING_NAME": "Completions configuration: missing name",
        "COMPLETION_CONFIG_MISSING_PROVIDER": "Completions configuration: missing provider",
        "COMPLETION_CONFIG_MISSING_ENDPOINT": "Completions configuration: missing endpoint",
        "COMPLETION_CONFIG_MISSING_API_KEY": "Completions configuration: missing API key",
        "COMPLETION_CONFIG_MISSING_MODEL": "Completions configuration: missing model",
        "COMPLETION_CONFIG_NO_PURPOSE_SPECIFIED": "Completions configuration: at least one completions type must be specified",
        "COMPLETION_CONFIG_INVALID_NAME": "Completions configuration: invalid name",
        "COMPLETION_CONFIG_INVALID_PURPOSE": "Completions configuration: invalid completions type",
        "COMPLETION_CONFIG_INVALID_ENDPOINT": "Completions configuration: invalid endpoint",
        "COMPLETION_CONFIG_INCONSISTENT_ENDPOINT": "Completions configuration: inconsistent endpoint",
        "COMPLETION_CONFIG_INVALID_PROVIDER": "Completions configuration: invalid provider",
        "COMPLETION_CONFIG_NOT_FOUND": "Completions configuration: not found",
        "COMPLETION_CONFIG_NOT_ACCESSIBLE": "Completions configuration: not accessible",
        "COMPLETION_CONFIG_NAME_RESERVED": "Completions configuration: name reserved",
        "COMPLETION_CONFIG_NAME_ALREADY_EXISTS": "Completions configuration: name already exists",
        "COMPLETION_CONFIG_VISIBILITY_CHANGE_NOT_ALLOWED": "Completions configuration: visibility change not allowed",
        "COMPLETION_CONFIG_MISSING_MANDATORY_PREFIX": "Completions configuration: missing mandatory prefix",
        "COMPLETION_CONFIG_VISIBILITY_NOT_PERMITTED": "Completions configuration: visibility not permitted",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_NOT_PERMITTED": "Completions configuration: use as default not permitted",
        "COMPLETION_CONFIG_USE_AS_DEFAULT_REQUIRES_TENANT_VISIBILITY": "Completions configuration: use as default requires tenant visibility",
        "COMPLETION_CONFIG_CHARGEABLE_NOT_PERMITTED": "Completions configuration: chargeable not permitted",
        "COMPLETION_CONFIG_INVALID_APPLY_TO": "Completions configuration: apply to invalid",
        "COMPLETION_CONFIG_APPLY_TO_TENANT_NOT_ALLOWED": "Completions configuration: apply to tenant not allowed",
        "TRUSTED_APPLICATION_NOT_FOUND": "Trusted application not found",
        "TRUSTED_APPLICATION_NOT_ACCESSIBLE": "Trusted application not accessible",
        "TRUSTED_APPLICATION_NAME_REQUIRED": "Trusted application: name required",
        "TRUSTED_APPLICATION_TOKEN_REQUIRED": "Trusted application: token required",
        "TRUSTED_APPLICATION_NAME_ALREADY_EXISTS": "Trusted application: name already exists",
        "TRUSTED_APPLICATION_INVALID_TOKEN": "Trusted application: invalid token"
    }
}
